module.exports = __webpack_public_path__ + "assets/img/tongyong.b1ae4df6.png";